export function fmtMoney(value, currency = "CAD") {
  return new Intl.NumberFormat("en-CA", { style: "currency", currency }).format(Number(value) || 0);
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function newKey() {
  return Math.random().toString(36).slice(2, 10);
}
